module.exports = __webpack_public_path__ + "static/media/qr_bg.88b3c75e.webp";